//natives
import React, { Component, useContext, useState, useEffect } from "react";
import clsx from "clsx";
import Cookies from "universal-cookie";
import { useTheme } from "@material-ui/core/styles";
import {
  Drawer,
  Hidden,
  CssBaseline,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  Collapse,
  Link,
  Badge,
} from "@material-ui/core";
import { Description, WhatsApp } from "@material-ui/icons";
import {
  Menu,
  ExpandLess,
  ExpandMore,
  VpnKey,
  PlaylistAddCheck,
  InsertDriveFile,
  LocalShipping,
  PersonAdd,
} from "@material-ui/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import TagManager from "react-gtm-module";
import base64 from "base-64";

//componentes
import Alerta from "../../../../util/snackbars/.mixins";
import PoliticasPrivacidade from "../../ui/politicasPrivacidade/.mixins/index";
import { Can } from "../../../../util/Can";

//controllers
import Auth from "../../../../../controllers/auth";
import Config from "../../../../../controllers/config";
import Pessoa_controller from "../../../../../controllers/pessoa";
import Log from "../../../../../controllers/log";
import GerenciarPedidos_controller from "../../../../../controllers/gerenciarPedidos";
import compliance from "../../../../../controllers/compliance";

import logoColor from "../../../../../assets/logo-color.png";
import logoWhite from "../../../../../assets/logo-white.png";

//css
import HeaderCss from "./styles";
import { AuthContext } from "../../../../../contexts/AuthContext";

import { useTotalPendingReturnProductsGql } from "../../ui/gerenciarPedidos/childrens/tabs/childrens/retiradasPendentes/.mixins/graphql/totalPendingProductReturn";

const useStyles = HeaderCss();

function breakLineAfterSecondSpace(str) {
  const n = 2; // second space
  const a = str.split(" ");
  const ident = a.slice(0, n).join(" ");
  let username = a.slice(n).join(" ");
  username = username.length > 21 ? `${username.substr(0, 21)}...` : username;

  return (
    <div>
      <Typography variant="body2">{username}</Typography>
      <Typography variant="caption">{ident}</Typography>
    </div>
  );
}

const logout = async () => {
  const cookies = new Cookies();
  const token = cookies.get("User-Token");

  //auditoria
  const str = "Efetuada requisição para logout! ";

  try {
    Log.info(token, str);
    const r_dados = await Auth.logout(token);
    if (r_dados.res.statusCode === 200) {
      cookies.remove("ga_informations");
      setTimeout(function () {
        window.location.reload();
      }, 300);
    } else {
      throw new Error("Erro na requisição para logout!");
    }
  } catch (error) {
    //auditoria
    const str = `Erro na requisição para logout!
        Error:( Message: ${error.message}, Stack: ${error.stack} )`;
    Log.error(token, str);
    console.error(error);
  }
};

function PersistentDrawerLeft(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [openDocs, setOpenDocs] = useState(false);
  const [openProductReturn, setOpenProductReturn] = useState(false);
  const [openNotaFiscal, setOpenNotaFiscal] = useState(false);
  const [openConfs, setOpenConfs] = useState(false);

  const { user } = useContext(AuthContext);

  const hasRole =
    user.role === "Master" ||
    user.role === "Admin - Comercial" ||
    user.role === "Admin - sourcing";

  const {
    runTotalPendingReturnProductsGql,
    dataTotalPendingReturnProducts,
    errorTotalPendingReturnProducts,
    loadingTotalPendingReturnProducts,
  } = useTotalPendingReturnProductsGql();

  useEffect(() => {
    if (!user.isVisaoTok) {
      runTotalPendingReturnProductsGql({
        variables: {
          personId: props.state.idPessoa,
          initialRow: 0,
          nextRows: 1,
        },
      });
    }
  }, [user.isVisaoTok, props.state.idPessoa]);

  const cookies = new Cookies();
  const color = cookies.get("System-Color");

  function handleDrawerOpen() {
    setOpen(true);
  }

  function handleDrawerClose() {
    setOpen(false);
  }

  const handleClickOpenDocs = () => {
    setOpenDocs(!openDocs);
  };

  const handleClickOpenProductReturn = () => {
    setOpenProductReturn(!openProductReturn);
  };

  const handleClickOpenNotaFiscal = () => {
    setOpenNotaFiscal(!openNotaFiscal);
  };

  const handleClickOpenConfs = () => {
    setOpenConfs(!openConfs);
  };

  const [openOptions, setOpenOptions] = useState(false);

  function handleClickOptions() {
    setOpenOptions(!openOptions);
  }

  function goto(link) {
    const cookies = new Cookies();
    const ga_informations = cookies.get("ga_informations");

    props.props.props.router.push(link);
    handleDrawerClose();

    // prepara variavel para module
    let abaModule = link.replace("/", "");
    abaModule = abaModule === "" ? "inicio" : abaModule;
    abaModule = abaModule.replace(/[A-Z]/g, (m) => "-" + m.toLowerCase());

    TagManager.dataLayer({
      dataLayer: {
        event: "event",
        eventCategory: "tokstok:fornecedores:geral",
        eventAction: "clique:menu-lateral",
        eventLabel: abaModule,
      },
    });

    if (ga_informations) {
      TagManager.dataLayer({
        dataLayer: JSON.parse(base64.decode(ga_informations)),
      });
    }
  }

  const drawer = (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "100%",
      }}
    >
      <div className={classes.drawerHeader}>
        <div className={"col-12"}>
          <br />
          {(color === "light" || color == null) && (
            <img src={logoColor} alt={"Tokstok"} width={"95%"} />
          )}
          {color === "dark" && (
            <img src={logoWhite} alt={"Tokstok"} width={"95%"} />
          )}
          <Typography
            variant="subtitle2"
            className={classes.lb_fornecedor}
            onClick={(e) => {
              goto("/perfil");
            }}
          >
            {breakLineAfterSecondSpace(props.state.usuario)}
          </Typography>
        </div>
      </div>

      <Divider />

      <List dense>
        <ListItem
          button
          onClick={(e) => {
            goto("/");
          }}
        >
          <ListItemIcon>
            <i className="material-icons">home</i>
          </ListItemIcon>
          <ListItemText primary={"Início"} />
        </ListItem>

        <Can
          some
          permissions={[
            "lista-de-pedidos-pendentes",
            "nova-tela-pedidos-pendentes",
          ]}
        >
          <ListItem
            button
            onClick={(e) => {
              if (user.permissions["nova-tela-pedidos-pendentes"])
                goto("/pendentesNova");
              else goto("/pendentes");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">assignment_turned_in</i>
            </ListItemIcon>
            <ListItemText primary="Pedidos não agendados" />
          </ListItem>
        </Can>

        <Can permissions={["lista-de-pedidos-agendados"]}>
          <ListItem
            button
            onClick={(e) => {
              goto("/agendados");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">event</i>
            </ListItemIcon>
            <ListItemText primary="Pedidos agendados" />
          </ListItem>
        </Can>

        <Can permissions={["protocolo-de-agendamento"]}>
          <ListItem
            button
            onClick={(e) => {
              goto("/protocolos");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">view_week</i>
            </ListItemIcon>
            <ListItemText primary={"Protocolo de agendamento"} />
          </ListItem>
        </Can>

        <Can permissions={["gerenciar-pedidos"]}>
          <ListItem
            button
            onClick={(e) => {
              goto("/gerenciarPedidos");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">date_range</i>
            </ListItemIcon>
            <Badge
              overlap="rectangular"
              badgeContent={props.state.qtd_notification}
              color="error"
            >
              <ListItemText primary={"Gerenciar Pedidos"} />
            </Badge>
            <Can permissions={["gerenciar-pedidos.retiradas-pendentes"]}>
              {dataTotalPendingReturnProducts.totalRows > 0 && (
                <div
                  style={{
                    backgroundColor: "#ffa000",
                    color: "#fff",
                    borderRadius: "1em",
                    height: "1.5em",
                    width: "1.5em",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "auto",
                    fontWeight: "bold",
                  }}
                  children={"!"}
                />
              )}
            </Can>
          </ListItem>
        </Can>

        <Can permissions={["historico-de-agendamento"]}>
          <ListItem
            button
            onClick={(e) => {
              goto("/historico-de-agendamento");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">visibility</i>
            </ListItemIcon>
            <ListItemText primary={"Histórico de agendamento"} />
          </ListItem>
        </Can>

        <Can permissions={["lista-de-pagamentos"]}>
          <ListItem
            button
            onClick={(e) => {
              goto("/pagamentos");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">attach_money</i>
            </ListItemIcon>
            <ListItemText primary="Pagamentos" />
          </ListItem>
        </Can>

        <Can permissions={["opcoes-de-recebimento"]}>
          <ListItem
            button
            onClick={(e) => {
              goto("/opcoesRecebimento");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">local_offer</i>
            </ListItemIcon>
            <ListItemText primary="Opções Recebimento" />
          </ListItem>
        </Can>

        <Can some permissions={["lista-de-notas", "acesso-envio-de-notas"]}>
          <ListItem button onClick={handleClickOpenNotaFiscal}>
            <ListItemIcon>
              <i className="material-icons">receipt</i>
            </ListItemIcon>
            <ListItemText primary="Nota Fiscal" />
            {openNotaFiscal ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openNotaFiscal} timeout="auto" unmountOnExit>
            <List dense component="div" disablePadding>
              <Can permissions={["lista-de-notas"]}>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={(e) => {
                    goto("/notas");
                  }}
                >
                  <ListItemIcon>
                    <i className="material-icons">receipt</i>
                  </ListItemIcon>
                  <ListItemText primary="Consultar Nota" />
                </ListItem>
              </Can>

              <Can permissions={["acesso-envio-de-notas"]}>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={(e) => {
                    goto("/notas/enviar");
                  }}
                >
                  <ListItemIcon>
                    <i className="material-icons">upload_file</i>
                  </ListItemIcon>
                  <ListItemText primary="Enviar Nota" />
                </ListItem>
              </Can>
            </List>
          </Collapse>
        </Can>

        <Can some permissions={["qualidade", "devolucao-recebimentos"]}>
          <ListItem button onClick={handleClickOpenProductReturn}>
            <ListItemIcon>
              <FontAwesomeIcon icon={faAward} style={{ marginLeft: "6px" }} />
            </ListItemIcon>
            <ListItemText primary="Qualidade" />
            {openProductReturn ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openProductReturn} timeout="auto" unmountOnExit>
            <List dense component="div" disablePadding>
              <Can permissions={["qualidade"]}>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={(e) => {
                    goto("/qualidade");
                  }}
                >
                  <ListItemIcon>
                    <Description />
                  </ListItemIcon>
                  <ListItemText primary="Ficha Técnica" />
                </ListItem>
              </Can>

              <Can permissions={["devolucao-recebimentos"]}>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={(e) => {
                    goto("/qualidade/devolucao");
                  }}
                >
                  <ListItemIcon>
                    <LocalShipping />
                  </ListItemIcon>
                  <ListItemText primary="Devolução" />
                  {props.state.pendingDocuments > 0 && (
                    <div
                      style={{
                        backgroundColor: "#ffa000",
                        color: "#fff",
                        borderRadius: "1em",
                        height: "1.5em",
                        width: "1.5em",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      children={props.state.pendingDocuments}
                    />
                  )}
                </ListItem>
              </Can>
            </List>
          </Collapse>
        </Can>

        <Can
          some
          permissions={[
            "manter-comunicados",
            "manter-contatos",
            "protocolo-logistico",
          ]}
        >
          <ListItem button onClick={handleClickOpenDocs}>
            <ListItemIcon>
              <InsertDriveFile />
            </ListItemIcon>
            <ListItemText primary="Documentos" />
            {!openDocs && props.state.pendingDocuments > 0 && !hasRole && (
              <div
                style={{
                  backgroundColor: "#ffa000",
                  color: "#fff",
                  borderRadius: "1em",
                  height: "1.5em",
                  width: "1.5em",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                children={props.state.pendingDocuments}
              />
            )}
            {openDocs ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
        </Can>

        <Collapse in={openDocs} timeout="auto" unmountOnExit>
          <List dense component="div" disablePadding>
            <Can permissions={["manter-comunicados"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/comunicados");
                }}
              >
                <ListItemIcon>
                  <i className="material-icons">announcement</i>
                </ListItemIcon>
                <ListItemText primary="Comunicados" />
              </ListItem>
            </Can>

            <Can permissions={["manter-contatos"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/contatos");
                }}
              >
                <ListItemIcon>
                  <i className="material-icons">contacts</i>
                </ListItemIcon>
                <ListItemText primary="Contatos" />
              </ListItem>
            </Can>

            <Can permissions={["protocolo-logistico"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/protocoloLogistico");
                }}
              >
                <ListItemIcon>
                  <i className="material-icons">assignment_turned_in</i>
                </ListItemIcon>
                <ListItemText primary="Protocolo Logístico" />
              </ListItem>
            </Can>

            <Can permissions={["user-compliance"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/compliance");
                }}
              >
                <ListItemIcon>
                  <PlaylistAddCheck />
                </ListItemIcon>
                <ListItemText primary="Compliance" />
                {props.state.pendingDocuments > 0 && !hasRole && (
                  <div
                    style={{
                      backgroundColor: "#ffa000",
                      color: "#fff",
                      borderRadius: "1em",
                      height: "1.5em",
                      width: "1.5em",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    children={props.state.pendingDocuments}
                  />
                )}
              </ListItem>
            </Can>

            <Can permissions={["documentos.cadastro-compl"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/cadastroComplementar");
                }}
              >
                <ListItemIcon>
                  <PersonAdd />
                </ListItemIcon>
                <ListItemText primary="Cadastro Complementar" />
              </ListItem>
            </Can>

            <Can permissions={['listar-formularios']}>
              <ListItem
                button
                className={classes.nested}
                onClick={() => {
                  goto("/formularios");
                }}
              >
                <ListItemIcon>
                  <i className="material-icons">assignment_turned_in</i>
                </ListItemIcon>
                <ListItemText primary="Formulários" />
              </ListItem>
            </Can>
          </List>
        </Collapse>

        <Can permissions={["manter-grupos"]}>
          <ListItem
            button
            onClick={(e) => {
              goto("/grupos");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">view_module</i>
            </ListItemIcon>
            <ListItemText primary="Grupos de contatos" />
          </ListItem>
        </Can>

        <Can permissions={["user-scorecard"]}>
          <ListItem
            button
            onClick={(e) => {
              goto("/scorecard");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">score</i>
            </ListItemIcon>
            <ListItemText primary="Scorecard" />
          </ListItem>
        </Can>

        <ListItem button onClick={handleClickOpenConfs}>
          <ListItemIcon>
            <i className="material-icons">settings</i>
          </ListItemIcon>
          <ListItemText primary="Configurações" />
          {openConfs ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={openConfs} timeout="auto" unmountOnExit>
          <List dense component="div" disablePadding>
            <ListItem
              button
              className={classes.nested}
              onClick={(e) => {
                goto("/temas");
              }}
            >
              <ListItemIcon>
                <i className="material-icons">dark_mode</i>
              </ListItemIcon>
              <ListItemText primary="Temas" />
            </ListItem>

            <Can permissions={["lista-de-usuarios"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/usuarios");
                }}
              >
                <ListItemIcon>
                  <i className="material-icons">how_to_reg</i>
                </ListItemIcon>
                <ListItemText primary="Liberação de acesso" />
              </ListItem>
            </Can>

            <Can permissions={["manter-permissoes"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/permissao");
                }}
              >
                <ListItemIcon>
                  <VpnKey />
                </ListItemIcon>
                <ListItemText primary="Tipo de Acesso" />
              </ListItem>
            </Can>

            <Can permissions={["grupos-opcoes-de-recebimento"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/grupoOpcoesRecebimento");
                }}
              >
                <ListItemIcon>
                  <i className="material-icons">local_offer</i>
                </ListItemIcon>
                <ListItemText primary="Grupos de Recebimento" />
              </ListItem>
            </Can>

            <Can permissions={["condicoes-de-pagamento"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/manutencaoCondicoesPagamento");
                }}
              >
                <ListItemIcon>
                  <i className="material-icons">group</i>
                </ListItemIcon>
                <ListItemText primary="Condições Pagamento" />
              </ListItem>
            </Can>

            <Can permissions={["logs"]}>
              <ListItem
                button
                className={classes.nested}
                onClick={(e) => {
                  goto("/logs");
                }}
              >
                <ListItemIcon>
                  <i className="material-icons">event_note</i>
                </ListItemIcon>
                <ListItemText primary="Logs" />
              </ListItem>
            </Can>
          </List>
        </Collapse>

        <Can permissions={["fale-conosco"]}>
          <ListItem
            button
            onClick={() => {
              goto("/contact");
            }}
          >
            <ListItemIcon>
              <i className="material-icons">email</i>
            </ListItemIcon>
            <ListItemText primary="Fale Conosco" />
          </ListItem>
        </Can>
      </List>

      <Divider />

      <List dense>
        <ListItem button onClick={(event) => logout()}>
          <ListItemIcon>
            <i className="material-icons">exit_to_app</i>
          </ListItemIcon>
          <ListItemText primary={"Logout"} />
        </ListItem>
      </List>

      <Divider />

      <div
        align={"center"}
        style={{
          paddingTop: "10px",
          paddingBottom: "0px",
          bottom: "0px",
          marginTop: "auto",
        }}
      >
        <Typography variant="caption">
          {`Versão: ${process.env.REACT_APP_VERSION}`}
          <br />
          <Link
            className={classes.linkText}
            onClick={props.handleDialogModalPoliticaPrivacidade}
            href="#"
          >
            Aviso de Privacidade
          </Link>
        </Typography>
      </div>
    </div>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />

      <Hidden smUp implementation="css">
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, open && classes.hide)}
              id={"iconMenu"}
            >
              <Menu />
            </IconButton>
            <a
              href={"#"}
              style={{ color: "white" }}
              onClick={(e) => {
                goto("/");
              }}
            >
              <Typography variant="h6" noWrap>
                Portal Fornecedor - TOKSTOK
              </Typography>
            </a>
          </Toolbar>
        </AppBar>

        <Drawer
          className={classes.drawer}
          variant="temporary"
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          {drawer}
        </Drawer>
      </Hidden>
      <Hidden only="xs" implementation="css">
        <Drawer
          className={classes.drawer}
          variant="permanent"
          anchor="left"
          open
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          {props.state.isLoading ? (
            <div align={"center"} width="100%">
              <CircularProgress />
            </div>
          ) : (
            <>{drawer}</>
          )}
        </Drawer>
      </Hidden>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.drawerHeader} />
      </main>
    </div>
  );
}

export default class Header extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.child = React.createRef();
    this.permissions = {};

    this.state = {
      usuario: "",
      idPessoa: "",
      qtd_notification: 0,
      isLoading: true,
      isError: false,
      error: null,
      openPoliticaPrivacidade: false,
      pendingDocuments: 0,
    };

    this.loadData = this.loadData.bind(this);
    this.handleDialogModalPoliticaPrivacidade =
      this.handleDialogModalPoliticaPrivacidade.bind(this);
  }
  handleDialogModalPoliticaPrivacidade() {
    this.setState({
      openPoliticaPrivacidade: !this.state.openPoliticaPrivacidade,
    });
  }

  componentWillMount() {
    this.permissions = this.context.user.permissions;
  }

  async componentDidMount() {
    // TagManager.dataLayer({
    //     dataLayer: {
    //         event: 'event',
    //         eventCategory: 'tokstok:fornecedores:geral',
    //         eventAction: 'componentDidMount',
    //         eventLabel: 'componente-menu',
    //     }
    // });

    await this.loadData();
  }

  async loadData() {
    const cookies = new Cookies();
    const token = cookies.get("User-Token");

    try {
      const o_pessoa = await Pessoa_controller.getByToken(token);
      let j_pessoa = JSON.parse(o_pessoa.body);
      if (o_pessoa.res.statusCode === 200) {
        const lb_rendered = `ID: ${j_pessoa.itens.codigo} ${j_pessoa.itens.nome}`;
        this.setState({
          usuario: lb_rendered,
          idPessoa: j_pessoa.itens.codigo,
        });
        window.usuario = j_pessoa.itens;
        cookies.set("User-Code", j_pessoa.itens.codigo);

        if (this.permissions["gerenciar-pedidos.pendentes"]) {
          await this.loadDataQtdAgendamentoPendentes(j_pessoa.itens.codigo);
        } else {
          this.setState({ isLoading: false });
        }

        if (
          this.permissions["user-compliance"] &&
          !this.permissions["admin-compliance"]
        ) {
          const { res, body } = await compliance.qtyDocumentsPending(
            token,
            cookies.get("User-Code")
          );
          const quantity = JSON.parse(body).quantity;
          if (res.statusCode === 200 && quantity > 0) {
            this.setState({ pendingDocuments: quantity });
          }
        }

        // TagManager.dataLayer({
        //     dataLayer: {
        //         event: 'event',
        //         eventCategory: 'tokstok:fornecedores:geral',
        //         eventAction: 'callback',
        //         eventLabel: `sucesso:${lb_rendered}`,
        //     }
        // });

        //auditoria
        let str = `Efetuada requisição para retorno de dados de pessoa!
                Response:( Method: ${o_pessoa.res.request.method}
                , StatusCode: ${o_pessoa.res.statusCode}
                , Body: (limited 100chars)${o_pessoa.body.substr(0, 100)} )`;
        Log.info(token, str);
      } else {
        throw new Error(
          "Campos necessários, não foram retornados pelo servidor!"
        );
      }
    } catch (error) {
      this.child.current.retorno(
        "Não foi possível carregar infomações de usuário!",
        "error"
      );
      let errorString = "Não foi possível carregar infomações de usuário!";
      if (Config.DEBUG === "TRUE") errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString,
        usuario: errorString,
      });

      // TagManager.dataLayer({
      //     dataLayer: {
      //         event: 'event',
      //         eventCategory: 'tokstok:fornecedores:geral',
      //         eventAction: 'callback',
      //         eventLabel: `erro:${error.message}`,
      //     }
      // });

      //auditoria
      const str = `Erro no retorno de dados de perfil!
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
      Log.error(token, str);
    }
  }

  loadDataQtdAgendamentoPendentes = async (personId) => {
    try {
      const filters = { personId };
      const cookies = new Cookies();
      const token = cookies.get("User-Token");
      const { res, body } = await GerenciarPedidos_controller.getQtdPen(
        token,
        filters
      );
      if (res.statusCode === 200) {
        const { quantity } = body;
        this.setState({ qtd_notification: quantity });
      } else {
        this.setState({ qtd_notification: 0 });
      }
      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({ qtd_notification: 0, isLoading: false });

      //auditoria
      const str = `Erro na requisição para quantidade de pedidos pendentes!
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
      Log.error(token, str);
    }
  };

  render() {
    return (
      <>
        <PersistentDrawerLeft {...this} />
        <Alerta ref={this.child} />
        <PoliticasPrivacidade {...this} />
      </>
    );
  }
}
